// 高亮属性
export interface HighlightData {
  text: string;
  highlight: boolean;
}

/**
 * 高亮属性文案处理
 */
export function highlightListForText(text: string) {
  const highlights: HighlightData[] = [];
  if (!text) {
    return highlights;
  }
  // 文案段
  const texts = text.split('<highlight>');
  for (let idx = 0; idx < texts.length; idx++) {
    const tt = texts[idx];
    if (tt) {
      if (tt.includes('</highlight>')) {
        const ts = tt.split('</highlight>');
        if (ts.length == 2) {
          if (ts[0]) {
            highlights.push({
              text: ts[0],
              highlight: true
            });
          }
          if (ts[1]) {
            highlights.push({
              text: ts[1],
              highlight: false
            });
          }
        }
      } else {
        highlights.push({
          text: tt,
          highlight: false
        });
      }
    }
  }
  return highlights;
}

// 返回移除 <highlight></highlight> 的文案
export function removeHighlightTagForText(text: string) {
  if (!text || !text.includes('<highlight>')) {
    return text;
  }
  let tt = text.replaceAll('<highlight>', '');
  tt = tt.replaceAll('</highlight>', '');
  return tt;
}

/** 区分颜色进行高亮 */
interface ColorHighlightData {
  text: string;
  highlight: boolean;
  highlightColor: 'red' | 'black' | 'none';
}

export function highlightListForTextWithColor(text: string): ColorHighlightData[] {
  const highlights: ColorHighlightData[] = [];
  if (!text) {
    return highlights;
  }

  const regex = /(<red>|<\/red>|<black>|<\/black>|<highlight>|<\/highlight>)/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let currentColor: 'red' | 'black' | 'none' = 'none';

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      highlights.push({
        text: text.substring(lastIndex, match.index),
        highlight: currentColor !== 'none',
        highlightColor: currentColor
      });
    }
    lastIndex = match.index + match[0].length;

    switch (match[0]) {
      case '<red>':
        currentColor = 'red';
        break;
      case '</red>':
        currentColor = 'none';
        break;
      case '<black>':
      case '<highlight>':
        currentColor = 'black';
        break;
      case '</black>':
      case '</highlight>':
        currentColor = 'none';
        break;
    }
  }

  if (lastIndex < text.length) {
    highlights.push({
      text: text.substring(lastIndex),
      highlight: currentColor !== 'none',
      highlightColor: currentColor
    });
  }

  return highlights;
}
